module.exports = __webpack_public_path__ + "img/gaugeMeter.8ddd7174.svg";